import { useUserStore } from '@rendora/common/store';
import { IRightsType } from '@rendora/common/types/enums';
import { showBuyEquityModal, showUpgradeEquityModal } from '../payment';

export const useUpgrade = () => {
  const userInfo = useUserStore();

  // 是否展示升级内容
  const showUpgrade = (config_type: number) => {
    return (userInfo?.user?.rights_type || 0) < config_type && userInfo.user?.user_id;
  };

  const onUpgrade = (config_type: number) => {
    // 入门版直接弹付费升级
    if (
      IRightsType.PERSONAL_LITE === userInfo?.user?.rights_type &&
      config_type === IRightsType.PERSONAL
    ) {
      showUpgradeEquityModal();
      return;
    }
    showBuyEquityModal({
      targetType: (config_type as IRightsType) || undefined,
    });
  };

  return {
    showUpgrade,
    onUpgrade,
  };
};
